<template>
  <div style="background: #f2f2f6;height:calc(100vh - 60px);overflow-y:auto">
        <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>产品管理</el-breadcrumb-item>
  <el-breadcrumb-item>产品列表</el-breadcrumb-item>
</el-breadcrumb>
<el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="8">
       <el-form-item label="名称编号">
        <el-input style="width:100%" v-model="where.title" placeholder="请输入" clearable></el-input>
  </el-form-item>
    </el-col>
    <el-col :span="8">
       <el-form-item label="状态">
    <el-select clearable  style="width:100%" v-model="where.status" >
            <el-option label="上架中" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
          </el-select>
  </el-form-item>
    </el-col>
 <el-col :span="8">
       <el-form-item label="库存">
        <el-input style="width:100%" v-model="where.stock" placeholder="请输入"></el-input>
  </el-form-item>
    </el-col>
        <el-col :span="12">
          <el-form-item label="颗粒范围">
            <el-input size="mini" type="number" style="width:40%" placeholder="请输入" v-model="where.minpce"  ></el-input>
            <span style="color:#666">~</span><el-input size="mini" type="number" style="width:40%" placeholder="请输入" v-model="where.maxpce" ></el-input>
      </el-form-item>

      </el-col>
       <el-col :span="12" style="text-align:right">
        <el-button size="small" type="primary" @click="searchProduct(1)">查询</el-button>
          <el-divider  direction="vertical"></el-divider>
         <el-button  title="新增"  type="success"  size="small" icon="el-icon-plus" @click="$router.push({name:'EditProduct',params:{innerid:-1}})"></el-button>

      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          height="calc(100% - 207px)"
          style="font-size:12px; width: calc(100% - 60px); border-radius: 10px;margin:0 30px"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{'line-height': '20px', padding: '8px', 'text-align': 'center' }"
          class="el-table"
        >
          <el-table-column
            type="index"
            fixed
            label="序号"
            :index="indexMethod"
            width="80"
          ></el-table-column>
           <el-table-column prop="innerid" label="商品ID" width="70" >
          </el-table-column>
          <el-table-column prop="title" label="名称"  >
          <template slot-scope="scope">
               {{scope.row.title}}<span v-if="scope.row.status==2" style="color:red">(已下架)</span>
            </template>
          </el-table-column>
          <el-table-column prop="cover" label="封面" width="100">
             <template slot-scope="scope">
               <el-image
    style="width: 40px; height: 40px"
    :src="scope.row.cover" :preview-src-list="[scope.row.cover]">
  </el-image>
            </template>
          </el-table-column>
            <el-table-column prop="pcs"   width="75"  label="颗粒数">
          </el-table-column>
          <el-table-column prop="price" width="75"  label="日租金">
          </el-table-column>
          <el-table-column prop="deposit"  width="75" label="押金">
          </el-table-column>
          <el-table-column prop="stock" width="75"  label="库存">
            <template slot-scope="scope">
               <span :style="{color:scope.row.stock==0?'red':'green'}">{{ scope.row.stock }}</span>
                <el-button class="el-icon-edit" size="mini" title="编辑" type="text" @click="editProductStock(scope.row)"></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="createdtime" label="入库日期" width="150">
          </el-table-column>
             <el-table-column
            column-key="opt"
            label="操作"
             width="200"
            >
            <template slot-scope="scope">
            <el-button class="el-icon-document-copy" size="mini" title="复制" type="warning" @click="duplicateProduct(scope.row)"></el-button>
            <el-button class="el-icon-edit" size="mini" title="编辑" type="success" @click="$router.push({name:'EditProduct',params:{innerid:scope.row.innerid}})"></el-button>
            <el-button class="el-icon-delete"  size="mini" title="删除" type="danger" @click="delProduct(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
   <el-row>

        <el-pagination
          background
          :page-sizes="[10,20, 50]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:20px"
        >
        </el-pagination>

    </el-row>
  </div>

</template>

<script>
import Vue from 'vue'
let customer
export default {
  name: 'Devices',
  data () {
    return {
      dialogFormVisible: false,
      tabledata: [],
      pageset: {
        size: 20,
        index: 1
      },
      totalsize: 0,
      where: {
      }
    }
  },
  mounted: function () {
    var self = this
    customer = window.localStorage.getItem('customer')
    if (customer) {
      this.searchProduct()
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  destroyed: function () {

  },
  methods: {
    searchProduct (index) {
      if (index) {
        this.pageset.index = index
      }
      this.tabledata = []
      Vue.axios
        .post('/product/list', {
          where: this.where,
          pageset: this.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tabledata = res.data.msgbody
            this.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/product/list/count', {
          where: this.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchProduct()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchProduct()
    },
    delProduct (row) {
      this.$confirm(
        '确认删除' + row.title + '？',
        this.$t('base.info'),
        {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/product/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: self.$t('base.delSuccess')
                })
                self.searchProduct()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    },
    duplicateProduct (row) {
      let self = this
      Vue.axios
        .post('/product/duplicate', {innerid: row.innerid})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.$message({
              type: 'success',
              message: '复制成功'
            })
            self.searchProduct()
          } else {
            self.$message({
              showClose: true,
              message:
                    res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    editProductStock (row) {
      let self = this
      this.$prompt('编辑库存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.stock,
        inputPattern: /^[0-9]\d*$/,
        inputErrorMessage: '请输入正确的库存数量'
      }).then(({ value }) => {
        Vue.axios
          .post('/product/stock/edit', {innerid: row.innerid, stock: value})
          .then((res) => {
            if (res.data.errcode == 0) {
              self.$message({
                type: 'success',
                message: '库存更新成功'
              })
              self.searchProduct()
            } else {
              self.$message({
                showClose: true,
                message:
                    res.data.errmsg || this.$t('base.systemError'),
                type: 'error'
              })
            }
          })
      }).catch(() => {

      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-table >>> .cell {
  padding: 0 !important;
}

.success{
  color:#67c23a
}

.danger{
  color:red
}

.info{
  color:gray
}

</style>



// WEBPACK FOOTER //
// src/components/Product/productList.vue